import { MutabilityClient } from './MutabilityClient';

export const NOT_EDITABLE: any = 'not_editable';

export const NOT_EDITABLE_FIELD: any = 'field';

export const NOT_EDITABLE_REASON: any = 'reason';

// eslint-disable-next-line import/no-anonymous-default-export
const _default_1: MutabilityClient = new MutabilityClient();

export default _default_1;
